import React, { useEffect, useState } from "react";
import "../css/MessageEMP.css";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import CustomButton from "./CustomButton";

const EmployeeDetails = () => {
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null); // ✅ Added
  const [selectAll, setSelectAll] = useState(false);
  const [multiNumbers, setMultiNumbers] = useState("");
  const [messageData, setMessageData] = useState({
    dearName: "",
    text: ""
  });

  // Fetch states on load
  useEffect(() => {
    fetch(`${BASE_URL}/api/states`,{
      headers:getAuthHeaders()
    })
      .then((res) => res.json())
      .then((data) => setStates(data))
      .catch((err) => console.error(err));
  }, []);

  // Fetch employees on button click
  const fetchEmployees = () => {
    if (!selectedState) return;
    fetch(`${BASE_URL}/api/employees?state_id=${selectedState}`,{
      headers:getAuthHeaders()
    })
      .then((res) => res.json())
      .then((data) => {
        setEmployees(data);
        setSelectedEmployees([]);
        setSelectAll(false);
        setSelectedEmployee(null);
      })
      .catch((err) => console.error(err));
  };

  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
  
    if (isChecked) {
      const allIds = employees.map((emp) => emp.id);
      setSelectedEmployees(allIds);
  
      // Collect all mobile numbers and names
      const mobileNumbers = employees.map((emp) => `+91${emp.mobile}`).join(':');
      const names = employees.map((emp) => `${emp.first_name} ${emp.last_name}`).join(',');
  
      // No specific "selectedEmployee" for multi, so leave it null
      setSelectedEmployee(null);
      setMessageData({
        dearName: names,
        text: ""
      });
  
      setMultiNumbers(mobileNumbers);  // we'll define this state
    } else {
      setSelectedEmployees([]);
      setSelectedEmployee(null);
      setMessageData({ dearName: "", text: "" });
      setMultiNumbers("");
    }
  };

  const handleCheckboxChange = (empId) => {
    setSelectedEmployees((prevSelected) => {
      const newSelected = prevSelected.includes(empId)
        ? prevSelected.filter((id) => id !== empId)
        : [...prevSelected, empId];
  
      // Reset selected employee if the unchecked one was selected
      if (selectedEmployee?.id === empId && !newSelected.includes(empId)) {
        setSelectedEmployee(null);
        setMessageData({ dearName: "", text: "" });
      }
  
      return newSelected;
    });
  };

  const handleEmployeeSelect = (emp) => {
    setSelectedEmployee(emp);
    setMessageData({
      dearName: `${emp.first_name} ${emp.last_name}`,
      text: ""
    });
  };

  const handleSendSMS = () => {
    // If multiple employees are selected
    if (selectedEmployees.length > 1 || (!selectedEmployee && multiNumbers)) {
      const selectedEmps = employees.filter(emp =>
        selectedEmployees.includes(emp.id)
      );
  
      const names = selectedEmps.map(emp => `${emp.first_name} ${emp.last_name}`);
      const mobiles = selectedEmps.map(emp => `+91${emp.mobile}`);
  
      const payload = {
        names,
        mobiles,
        message_text: messageData.text
      };
  
      fetch(`${BASE_URL}/api/send_custom_message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(res => res.json())
        .then(data => {
          if (data.sent?.length) {
            alert(`Messages sent to ${data.sent.length} employees`);
            setMessageData({ dearName: "", text: "" });
            setSelectedEmployees([]);
            setSelectAll(false);                    // ✅ Uncheck all
            setSelectedEmployee(null);
            setMultiNumbers("");
          } else {
            alert("Failed to send messages.");
          }
        })
        .catch(err => {
          alert("Error sending messages.");
          console.error(err);
        });
    }
  
    // If single employee selected
    else if (selectedEmployee) {
      const payload = {
        names: [`${selectedEmployee.first_name} ${selectedEmployee.last_name}`],
        mobiles: [`+91${selectedEmployee.mobile}`],
        message_text: messageData.text
      };
  
      fetch(`${BASE_URL}/api/send_custom_message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(res => res.json())
        .then(data => {
          if (data.sent?.length) {
            alert(`Message sent to ${selectedEmployee.first_name} ${selectedEmployee.last_name}`);
            setMessageData({ dearName: "", text: "" });
            setSelectedEmployees([]);
            setSelectAll(false);                    // ✅ Uncheck all
            setSelectedEmployee(null);
          } else {
            alert("Failed to send message.");
          }
        })
        .catch(err => {
          alert("Error sending message.");
          console.error(err);
        });
    }
  };
  
  

  return (
   <div className="p-2  border-2 border-gray-300 rounded-lg bg-white">


      <div className="p-4 border-2 border-gray-300 rounded-lg bg-gray-50">

         <div className="mb-8">
    <h2 className="text-2xl font-bold text-gray-800 border-b pb-2">Simple Message Basic Details</h2>
  </div>

        {/* Filter and SMS Sections in one row */}
        <div className="filter-sms-row">
          {/* Filter Section */}
          <div className="message-filter-section">
          
            <div className="filter-content">
             <label htmlFor="stateSelect" className="block text-sm font-medium text-gray-700 mb-1">
            State
          </label>
          <select
            id="stateSelect"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            value={selectedState}
            onChange={handleStateChange}
          >
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state.id} value={state.id}>
                {state.name}
              </option>
            ))}
          </select>
              <CustomButton variant="go" onClick={fetchEmployees}>
                Go
              </CustomButton>
            </div>
          </div>

          {/* SMS Section */}
          <div className="message-sms-section">
        <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">Send SMS</h3>
      </div>
            <div className="sms-content">
              {/* <div className="sms-field">
                <label>To Mobile Number:</label>
                <input
                  type="text"
                  value={selectedEmployee ? `+91${selectedEmployee.mobile}` : multiNumbers}
                  className="sms-input"
                  readOnly
                />
              </div>

              <div className="sms-field">
                <label>Dear:</label>
                <input
                  type="text"
                  value={messageData.dearName}
                  onChange={(e) =>
                    setMessageData({ ...messageData, dearName: e.target.value })
                  }
                  className="sms-input"
                />
              </div> */}

              <div className="sms-field">
                <label>Message:</label>
                <textarea
                  value={messageData.text}
                  onChange={(e) =>
                    setMessageData({ ...messageData, text: e.target.value })
                  }
                  className="sms-textarea"
                  rows="4"
                />
              </div>

              <div className="sms-actions">
                <button
                  className="send-sms-btn w-26 h-9"
                  onClick={handleSendSMS}
                  disabled={!selectedEmployee}
                >
                  Send SMS
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Employee Table Section - only show if employees exist */}
            {employees.length > 0 && (
            <div className="message-employee-section">
                <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">Employees List</h3>
      </div>
                    <div className="border rounded shadow no-scrollbar" style={{ maxHeight: "101vh", overflowY: "auto", overflowX: "auto" }}>
        <table className="min-w-full text-sm unlock-dcr-leave-table">
          <thead className="bg-blue-500 text-white">
                    <tr>
                        <th>
                        Send SMS
                        <br />
                        <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                        />
                        </th>
                        <th>S.No</th>
                        <th>User Name</th>
                        <th>Employee</th>
                        <th>State</th>
                        <th>HQ</th>
                        <th>Mobile</th>
                        <th>Designation</th>
                    </tr>
                    </thead>
                    <tbody>
                    {employees.map((emp, index) => (
                        <tr
                        key={emp.id}
                        onClick={() => handleEmployeeSelect(emp)}
                        style={{
                            backgroundColor:
                            selectedEmployee?.id === emp.id ? "#eef" : "transparent"
                        }}
                        >
                        <td>
                            <input
                            type="checkbox"
                            checked={selectedEmployees.includes(emp.id)}
                            onChange={() => handleCheckboxChange(emp.id)}
                            />
                        </td>
                        <td>{index + 1}</td>
                        <td>{emp.employee}</td>
                        <td>{emp.first_name} {emp.last_name}</td>
                        <td>{emp.state_name}</td>
                        <td>{emp.headquarter_name}</td>
                        <td>{emp.mobile}</td>
                        <td>{emp.designation}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            </div>
            )}
      </div>

    </div>
  );
};

export default EmployeeDetails;
